document.addEventListener('DOMContentLoaded', () => {
  const selector = document.querySelector('[data-scene-display-selector]');
  if (!selector) return;

  const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
  if (!productForm) return;

  const optionButtons = selector.querySelectorAll('.scene-display-option');
  const bundleModeProperty = document.getElementById('SceneBundleModeProperty');
  const bundleData = window.__SCENE_BUNDLE_DATA__;
  const includesBlock = document.querySelector('[data-scene-display-includes]');
  const bundlePriceValue = document.querySelector('[data-scene-bundle-price-value]');

  if (!bundleModeProperty || !bundleData) return;

  let currentMode = bundleModeProperty.value || 'sleeve';

  function getSubmitButtonTextSpan() {
    const submitButton = productForm.querySelector('.product-form__submit');
    if (!submitButton) return null;
    return submitButton.querySelector('span');
  }

  function updateButtonText(mode) {
    const buttonText = getSubmitButtonTextSpan();
    if (!buttonText) return;

    if (mode === 'sleeve') buttonText.textContent = 'Add Sleeve to Cart';
    if (mode === 'starter') buttonText.textContent = 'Add Starter Kit to Cart';
    if (mode === 'full') buttonText.textContent = 'Add Frame Bundle to Cart';
  }

  function updateIncludes(mode) {
    if (!includesBlock) return;

    if (mode === 'starter') {
      includesBlock.innerHTML = `
        <p class="scene-display-includes__title">Starter Kit Includes:</p>
        <ul class="scene-display-includes__list">
          <li>✓ Scene Sleeve</li>
          <li>✓ Matching Scene Board</li>
        </ul>
      `;
      return;
    }

    if (mode === 'full') {
  const sizeCode = getSelectedSizeCode();

  let savingsText = '';

  if (sizeCode === 'MD') savingsText = 'Save $2';
  if (sizeCode === 'LG') savingsText = 'Save $3';

  includesBlock.innerHTML = `
    <p class="scene-display-includes__title">Frame Bundle Includes:</p>
    <ul class="scene-display-includes__list">
      <li>✓ Scene Sleeve</li>
      <li>✓ Matching Scene Board</li>
      <li>✓ Matching Scene Frame</li>
    </ul>
    ${savingsText ? `<p class="scene-display-savings">${savingsText}</p>` : ''}
  `;
  return;
}

    includesBlock.innerHTML = `
      <p class="scene-display-includes__title">Includes:</p>
      <ul class="scene-display-includes__list">
        <li>✓ Scene Sleeve</li>
      </ul>
    `;
  }

  function updateMode(mode) {
    currentMode = mode;
    bundleModeProperty.value = mode;

    optionButtons.forEach((button) => {
      button.classList.toggle('is-active', button.dataset.displayOption === mode);
    });

    updateButtonText(mode);
    updateIncludes(mode);
    updateBundlePrice();
  }

  optionButtons.forEach((button) => {
    button.addEventListener('click', () => updateMode(button.dataset.displayOption));
  });

  function getSelectedVariantId() {
    const variantInput = productForm.querySelector('input[name="id"]');
    return variantInput ? Number(variantInput.value) : null;
  }

  function getSelectedSizeCode() {
    const checkedOption = document.querySelector('.product-form__input input[type="radio"]:checked');
    if (checkedOption) return normalizeSizeCode(checkedOption.value);

    const selectOption = document.querySelector('.product-form__input select');
    if (selectOption) return normalizeSizeCode(selectOption.value);

    return null;
  }

  function normalizeSizeCode(value) {
    if (!value) return null;

    const text = String(value).toLowerCase().trim();

    if (text.includes('small') || text === 'sm') return 'SM';
    if (text.includes('medium') || text === 'md') return 'MD';
    if (text.includes('large') || text === 'lg') return 'LG';
    if (text.includes('xl') || text.includes('extra')) return 'XL';

    return String(value).toUpperCase();
  }

  function findMatchingBySize(products, sizeCode) {
    if (!products || !sizeCode) return null;

    return products.find((product) => {
      return String(product.size_code).toUpperCase() === String(sizeCode).toUpperCase();
    });
  }

  function findSleeveVariantPrice() {
    const selectedVariantId = getSelectedVariantId();
    if (!bundleData.sleeveVariants) return 0;

    const variant = bundleData.sleeveVariants.find((item) => Number(item.id) === Number(selectedVariantId));
    return variant ? Number(variant.price || 0) : 0;
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: bundleData.currency || 'USD'
    }).format(cents / 100);
  }

  function calculateBundleTotal() {
    const sizeCode = getSelectedSizeCode();
    let total = findSleeveVariantPrice();

    if (currentMode === 'starter' || currentMode === 'full') {
      const matchingBoard = findMatchingBySize(bundleData.boards, sizeCode);
      if (matchingBoard) total += Number(matchingBoard.price || 0);
    }

    if (currentMode === 'full') {
      const matchingFrame = findMatchingBySize(bundleData.frames, sizeCode);
      if (matchingFrame) total += Number(matchingFrame.price || 0);

      if (sizeCode === 'MD') total -= 200;
      if (sizeCode === 'LG') total -= 300;
    }

    return Math.max(total, 0);
  }

function updateBundlePrice() {
  if (!bundlePriceValue) return;

  const sizeCode = getSelectedSizeCode();

  let originalTotal = findSleeveVariantPrice();

  if (currentMode === 'starter' || currentMode === 'full') {
    const matchingBoard = findMatchingBySize(bundleData.boards, sizeCode);
    if (matchingBoard) originalTotal += Number(matchingBoard.price || 0);
  }

  if (currentMode === 'full') {
    const matchingFrame = findMatchingBySize(bundleData.frames, sizeCode);
    if (matchingFrame) originalTotal += Number(matchingFrame.price || 0);
  }

  const discountedTotal = calculateBundleTotal();

  let html = formatMoney(discountedTotal);

  if (currentMode === 'full' && originalTotal > discountedTotal) {
    html = `
      <span class="scene-price-original">${formatMoney(originalTotal)}</span>
      <span class="scene-price-discounted">${formatMoney(discountedTotal)}</span>
    `;
  }

  if (bundlePriceValue.dataset.lastHtml !== html) {
    bundlePriceValue.dataset.lastHtml = html;
    bundlePriceValue.innerHTML = html;
  }
}

  function refreshBundleUI() {
    updateButtonText(currentMode);
    updateIncludes(currentMode);
    updateBundlePrice();
  }

  document.addEventListener('change', () => {
  setTimeout(refreshBundleUI, 250);
});

  productForm.addEventListener('submit', async (event) => {
    if (currentMode === 'sleeve') return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const sleeveVariantId = getSelectedVariantId();
    const sizeCode = getSelectedSizeCode();

    if (!sleeveVariantId || !sizeCode) {
      alert('Could not determine the selected sleeve size.');
      return;
    }

    const items = [{ id: sleeveVariantId, quantity: 1 }];

    if (currentMode === 'starter' || currentMode === 'full') {
      const matchingBoard = findMatchingBySize(bundleData.boards, sizeCode);
      if (matchingBoard && matchingBoard.variant_id) {
        items.push({ id: Number(matchingBoard.variant_id), quantity: 1 });
      } else {
        alert(`Could not find a matching board for size ${sizeCode}.`);
        return;
      }
    }

    if (currentMode === 'full') {
      const matchingFrame = findMatchingBySize(bundleData.frames, sizeCode);
      if (matchingFrame && matchingFrame.variant_id) {
        items.push({ id: Number(matchingFrame.variant_id), quantity: 1 });
      } else {
        alert(`Could not find a matching frame for size ${sizeCode}.`);
        return;
      }
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });

      if (!response.ok) throw new Error('Bundle add failed');

      window.location.href = '/cart';
    } catch (error) {
      console.error(error);
      alert('There was a problem adding the bundle to cart.');
    }
  }, true);

  updateMode(currentMode);
});